import React from 'react'
import { Helmet } from 'react-helmet'
import EshopCategory from './EshopCategory'

const EshopMoyen = ({ products = [], eshopInfo = null }) => (
    <>
        <Helmet>
            <title>Moyen format | Marguerite Soulier</title>
            <link rel="canonical" href="https://margueritesoulier.fr/moyen-format" />
            <meta property="og:url" content="https://margueritesoulier.fr/moyen-format" />
        </Helmet>
        <EshopCategory products={products} category="moyen" eshopInfo={eshopInfo} />
    </>
)

export default EshopMoyen